import {
  // getReq,
  postReq,
  deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  exportExcelReq,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  emptySearchInfo: {
    searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    searchCtrAcctId: '',
    searchFundStatEntityIdList: [],
    searchFundStatEntityList: [],
    searchEntityId: '',
    searchPaymentId: ''
  },
  searchInfo: {
    searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    searchCtrAcctId: '',
    searchFundStatEntityIdList: [],
    searchFundStatEntityList: [],
    searchEntityId: '',
    searchPaymentId: ''
  },
  searchedForm: {},
  transList: [],
  transInfo: {
    transId: '',
    colType: '',
    compId: '',
    projId: '',
    entityId: '',
    fundStatEntityId: '',
    entityType: '',
    incomeType: '',
    paymentType: '',
    ctrAcctId: '',
    refId: '',
    tgtCtrAcctId: '',
    transDt: '',
    transSummary: '',
    inAmt: 0,
    outAmt: 0,
    balAmt: 0,
    paymentId: '',
    transIndex: '',
    transRemarks: '',
    crtBy: '',
    crtOn: new Date(0),
    updBy: '',
    updOn: new Date(0),
    //
    indUsed: ''
  },
  editIndex: -1,
  justUpdatedIndex: -1,
  editAction: '',
  cashierFlowFundStatAcct: {},
  END_STATE: null
}

const getters = {

}

const actions = {
  async insertCashierFlowTrans({
    dispatch,
    commit,
    state
  }, {projId, compId, fundStatEntity, codeParam}) {
    // debugger
    const insertObj = await postReq(END_POINTS.INSERT_CASHIER_FLOW_TRANS, {
      data: {
        // transId: state.transInfo.transId,
        colType: state.transInfo.colType || '',
        // compId: state.transInfo.compId,
        // projId: state.transInfo.projId,
        entityId: state.transInfo.entityId || '',
        // ctrAcctId: state.transInfo.ctrAcctId,
        fundStatEntityId: state.transInfo.fundStatEntityId,
        entityType: fundStatEntity.entityType,
        incomeType: fundStatEntity.incomeType,
        paymentType: fundStatEntity.paymentType,
        ctrAcctId: fundStatEntity.ctrAcctId,
        refId: fundStatEntity.refId,
        transDt: state.transInfo.transDt,
        transSummary: state.transInfo.transSummary,
        inAmt: Utils.covertNullToZero(state.transInfo.inAmt),
        outAmt: Utils.covertNullToZero(state.transInfo.outAmt),
        balAmt: Utils.covertNullToZero(state.transInfo.balAmt),
        paymentId: state.transInfo.paymentId || '',
        transIndex: state.transInfo.transIndex,
        transRemarks: state.transInfo.transRemarks,
        //
        // entityId: entityId,
        projId: projId,
        compId: compId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return insertObj
  },
  async updateCashierFlowTrans({
    dispatch,
    commit,
    state
  }, {transId, projId, compId, fundStatEntity, codeParam}) {
    // console.log(transId)
    // debugger
    let transInfo = {
      // transId: state.transInfo.transId,
      colType: state.transInfo.colType || '',
      // compId: state.transInfo.compId,
      // projId: state.transInfo.projId,
      entityId: state.transInfo.entityId || '',
      // ctrAcctId: state.transInfo.ctrAcctId,
      fundStatEntityId: state.transInfo.fundStatEntityId,
      entityType: fundStatEntity.entityType,
      incomeType: fundStatEntity.incomeType,
      paymentType: fundStatEntity.paymentType,
      ctrAcctId: fundStatEntity.ctrAcctId,
      refId: fundStatEntity.refId,
      transDt: state.transInfo.transDt,
      transSummary: state.transInfo.transSummary,
      inAmt: Utils.covertNullToZero(state.transInfo.inAmt),
      outAmt: Utils.covertNullToZero(state.transInfo.outAmt),
      balAmt: Utils.covertNullToZero(state.transInfo.balAmt),
      paymentId: state.transInfo.paymentId || '',
      transIndex: state.transInfo.transIndex,
      transRemarks: state.transInfo.transRemarks,
      //
      key: {
        transId: transId,
        // entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_CASHIER_FLOW_TRANS, {
      data: transInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async removeCashierFlowTrans({
    commit,
    state
  }, {transId, projId, compId, codeParam}) {
    const deleteObject = await deleteSendReq(END_POINTS.REMOVE_CASHIER_FLOW_TRANS + `?transId=${transId}&&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return deleteObject
  },
  async findCashierFlowTransList({
    commit,
    state,
    rootState
  }, {transId, projId, compId, codeParam}) {
  // }, { projId, compId, searchEntityId, fundStatEntityList, searchCtrAcctId, searchMonth, searchType, startDt, endDt }) {

    let searchedForm = state.searchedForm || state.emptySearchInfo
    // console.log('emptySearchInfo:', state.emptySearchInfo)
    // console.log('searchedForm:', searchedForm)
    // debugger
    let data = {
      transId,
      projId,
      compId,
      entityId: searchedForm.searchEntityId,
      paymentId: searchedForm.searchPaymentId,
      fundStatEntityList: searchedForm.searchFundStatEntityList,
      ctrAcctId: searchedForm.searchCtrAcctId,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime()
    }
    const response = await postReq(END_POINTS.FIND_CASHIER_FLOW_TRANS_LIST, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return response
    // commit('updateTransList', response)
  },
  async downloadCashierFlowTransList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    let searchedForm = state.searchedForm || state.emptySearchInfo
    // console.log('emptySearchInfo:', state.emptySearchInfo)
    // console.log('searchedForm:', searchedForm)
    // debugger
    let data = {
      projId,
      compId,
      entityId: searchedForm.searchEntityId,
      paymentId: searchedForm.searchPaymentId,
      fundStatEntityList: searchedForm.searchFundStatEntityList,
      ctrAcctId: searchedForm.searchCtrAcctId,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime()
    }
    const response = await exportExcelReq(END_POINTS.DOWNLOAD_CASHIER_FLOW_TRANS_LIST, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    // console.log('exportExcelReq.resp:', response)
    return response
  },
  async findCashierFlowFundStatAcct({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    let searchedForm = state.searchedForm || state.emptySearchInfo
    // console.log('emptySearchInfo:', state.emptySearchInfo)
    // console.log('searchedForm:', searchedForm)
    // debugger
    let data = {
      // transId,
      projId,
      compId,
      entityId: searchedForm.searchEntityId,
      paymentId: searchedForm.searchPaymentId,
      fundStatEntityList: searchedForm.searchFundStatEntityList,
      ctrAcctId: searchedForm.searchCtrAcctId,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime()
    }
    // let searchMonth = new Date(searchedForm.searchMonth).getTime()
    // let startDt = new Date(searchedForm.searchDtScope[0]).getTime()
    // let endDt = new Date(searchedForm.searchDtScope[1]).getTime()
    const response = await postReq(END_POINTS.FIND_CASHIER_FLOW_FUND_STAT_ACCT, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateCashierFlowFundStatAcct', response)
  },
  END_ACTIONS() {}
}

const mutations = {
  async updateSearchedForm(state) {
    state.searchedForm = {...state.searchInfo}
  },
  // async updateSearchInfo(state, searchInfo) {
  //   state.searchInfo = {...searchInfo}
  // },
  async resetSearchInfo(state) {
    state.searchInfo = {...state.emptySearchInfo}
  },
  updateSearchType(state, value) {
    state.searchInfo.searchType = value
  },
  updateSearchMonth(state, value) {
    state.searchInfo.searchMonth = value
  },
  updateSearchMonthType(state, value) {
    state.searchInfo.searchMonthType = value
  },
  // updateSearchDtScope(state, value) {
  //   state.searchInfo.searchDtScope = value
  // },
  updateSearchStartDt(state, value) {
    state.searchInfo.searchStartDt = value
  },
  updateSearchEndDt(state, value) {
    state.searchInfo.searchEndDt = value
  },
  updateSearchCtrAcctId(state, value) {
    state.searchInfo.searchCtrAcctId = value
  },
  updateSearchFundStatEntityIdList(state, value) {
    state.searchInfo.searchFundStatEntityIdList = value
  },
  updateSearchFundStatEntityList(state, value) {
    state.searchInfo.searchFundStatEntityList = value
  },
  updateSearchEntityId(state, value) {
    state.searchInfo.searchEntityId = value
  },
  updateSearchPaymentId(state, value) {
    state.searchInfo.searchPaymentId = value
  },
  updateSearchFundStatEntityIdListEmpty(state, value) {
    state.searchInfo.searchFundStatEntityIdList = []
  },
  updateSearchFundStatEntityIdListAdd(state, value) {
    state.searchInfo.searchFundStatEntityIdList.push(value)
  },
  //
  updateTransId(state, value) {
    state.transInfo.transId = value
  },
  updateColType(state, value) {
    state.transInfo.colType = value
  },
  updateCompId(state, value) {
    state.transInfo.compId = value
  },
  updateProjId(state, value) {
    state.transInfo.projId = value
  },
  updateEntityId(state, value) {
    state.transInfo.entityId = value
  },
  updateFundStatEntityId(state, value) {
    state.transInfo.fundStatEntityId = value
  },
  updateEntityType(state, value) {
    state.transInfo.entityType = value
  },
  updateIncomeType(state, value) {
    state.transInfo.incomeType = value
  },
  updatePaymentType(state, value) {
    state.transInfo.paymentType = value
  },
  updateCtrAcctId(state, value) {
    state.transInfo.ctrAcctId = value
  },
  updateRefId(state, value) {
    state.transInfo.refId = value
  },
  updateTgtCtrAcctId(state, value) {
    state.transInfo.tgtCtrAcctId = value
  },
  updateTransDt(state, value) {
    state.transInfo.transDt = value
  },
  updateTransSummary(state, value) {
    state.transInfo.transSummary = value
  },
  updateInAmt(state, value) {
    state.transInfo.inAmt = value
  },
  updateOutAmt(state, value) {
    state.transInfo.outAmt = value
  },
  updateBalAmt(state, value) {
    state.transInfo.balAmt = value
  },
  updatePaymentId(state, value) {
    state.transInfo.paymentId = value
  },
  updateTransIndex(state, value) {
    state.transInfo.transIndex = value
  },
  updateTransRemarks(state, value) {
    state.transInfo.transRemarks = value
  },
  updateIndDel(state, value) {
    state.transInfo.indDel = value
  },
  updateCrtBy(state, value) {
    state.transInfo.crtBy = value
  },
  updateCrtOn(state, value) {
    state.transInfo.crtOn = value
  },
  updateUpdBy(state, value) {
    state.transInfo.updBy = value
  },
  updateUpdOn(state, value) {
    state.transInfo.updOn = value
  },
  //
  updateTransList(state, list) {
    if (list.length) {
      state.transList = list
      // state.transList = []
    } else {
      state.transList = []
    }
  },
  updateTransListItem(state, {row, index}) {
    if (state.transList && state.transList.length && index >= 0 && index < state.transList.length) {
      if (row) {
        Object.keys(row).forEach(key => {
          state.transList[index][key] = row[key]
        })
      } else {
        state.transList.splice(index, 1)
      }
    }
  },
  updateTransListEmpty(state) {
    state.editIndex = -1
    state.justUpdatedIndex = -1
    state.transList = []
  },
  updateTransEmpty(state) {
    state.transInfo.transId = ''
    state.transInfo.colType = ''
    state.transInfo.compId = ''
    state.transInfo.projId = ''
    state.transInfo.entityId = ''
    state.transInfo.fundStatEntityId = ''
    state.transInfo.entityType = ''
    state.transInfo.incomeType = ''
    state.transInfo.paymentType = ''
    state.transInfo.ctrAcctId = ''
    state.transInfo.refId = ''
    state.transInfo.tgtCtrAcctId = ''
    state.transInfo.transDt = new Date(0)
    state.transInfo.transSummary = ''
    state.transInfo.inAmt = Utils.covertZeroToNull(0)
    state.transInfo.outAmt = Utils.covertZeroToNull(0)
    state.transInfo.balAmt = Utils.covertZeroToNull(0)
    state.transInfo.paymentId = ''
    state.transInfo.transIndex = ''
    state.transInfo.transRemarks = ''
    state.transInfo.crtBy = ''
    state.transInfo.crtOn = new Date(0)
    state.transInfo.updBy = ''
    state.transInfo.updOn = new Date(0)

    state.transInfo.indUsed = ''
  },
  updateTransInfo(state, transInfo) {
    // debugger
    state.transInfo.transId = transInfo.transId
    state.transInfo.colType = transInfo.colType
    state.transInfo.compId = transInfo.compId
    state.transInfo.projId = transInfo.projId
    state.transInfo.entityId = transInfo.entityId
    state.transInfo.fundStatEntityId = transInfo.fundStatEntityId
    state.transInfo.entityType = transInfo.entityType
    state.transInfo.incomeType = transInfo.incomeType
    state.transInfo.paymentType = transInfo.paymentType
    state.transInfo.ctrAcctId = transInfo.ctrAcctId
    state.transInfo.refId = transInfo.refId
    state.transInfo.tgtCtrAcctId = transInfo.tgtCtrAcctId
    state.transInfo.transDt = transInfo.transDt
    state.transInfo.transSummary = transInfo.transSummary
    state.transInfo.inAmt = Utils.covertZeroToNull(transInfo.inAmt)
    state.transInfo.outAmt = Utils.covertZeroToNull(transInfo.outAmt)
    state.transInfo.balAmt = Utils.covertZeroToNull(transInfo.balAmt)
    state.transInfo.paymentId = transInfo.paymentId
    state.transInfo.transIndex = transInfo.transIndex
    state.transInfo.transRemarks = transInfo.transRemarks
    //
    state.transInfo.indUsed = transInfo.indUsed
  },
  updateEditIndex(state, value) {
    state.editIndex = value
  },
  updateJustUpdatedIndex(state, value) {
    state.justUpdatedIndex = value
  },
  updateEditAction(state, value) {
    state.editAction = value
  },
  // newEmptyRowObj() {
  //   return {
  //     ctrAcctId: '',
  //     type: '',
  //     indUsed: '',
  //     status: ''
  //   }
  // },
  appendBottomRow() {
    this.commit('cashierFlowTransManage/updateTransEmpty')
    let obj = {...state.transInfo}
    // debugger
    obj.isBottomRow = true
    state.transList.push(obj)
  },
  handleAdd(state, {row, index}) {
    // debugger
    this.commit('cashierFlowTransManage/updateTransEmpty')
    this.commit('cashierFlowTransManage/updateEditIndex', index)
    this.commit('cashierFlowTransManage/updateJustUpdatedIndex', -1)
    this.commit('cashierFlowTransManage/updateEditAction', 'insert')
    //
    // this.commit('cashierFlowTransManage/updateCtrAcctId', ctrAcctId)
    // this.commit('cashierFlowTransManage/updateCostColId', costColId)
  },
  handleEdit(state, {row, index}) {
    // debugger
    this.commit('cashierFlowTransManage/updateTransInfo', row)
    this.commit('cashierFlowTransManage/updateEditIndex', index)
    this.commit('cashierFlowTransManage/updateJustUpdatedIndex', -1)
    this.commit('cashierFlowTransManage/updateEditAction', 'update')
  },
  updateCashierFlowFundStatAcct(state, response) {
    if (response.success) {
      state.cashierFlowFundStatAcct = response.data
    } else {
      state.cashierFlowFundStatAcct = null
    }
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/cashierFlowTransManage.js